import ApiService from './api.service';

class UserService {
  async list() {
    try {
      const response = await ApiService.get('/user');
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async get(id) {
    try {
      const response = await ApiService.get(`/user/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async create(userData) {
    try {
      const response = await ApiService.post('/user/add', userData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async update(userData) {
    try {
      const response = await ApiService.put('/user/update', userData);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async delete(userId) {
    try {
      const response = await ApiService.delete('/user/delete', { id: userId });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async updatePin(id, pin) {
    try {
      const response = await ApiService.patch('/user/pin', { id, pin });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default new UserService();